import React, { useState } from 'react';
import ScrollToTop from '../components/ScrollToTop';
import Footer from '../components/Footer';
import NavbarHome from '../components/NavbarHome';
import Contact from '../components/ContactForms';
import VideoPlayer from '../components/VideoPlayer';

function DemoVideoPage() {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <ScrollToTop />
            <NavbarHome toggle={toggle} />
            <VideoPlayer />
            <Footer />
        </>
    );
}

export default DemoVideoPage;

